import { render, staticRenderFns } from "./MemberCert.vue?vue&type=template&id=6fd63bec&scoped=true&"
import script from "./MemberCert.vue?vue&type=script&lang=js&"
export * from "./MemberCert.vue?vue&type=script&lang=js&"
import style0 from "./MemberCert.vue?vue&type=style&index=0&id=6fd63bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd63bec",
  null
  
)

export default component.exports